// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fed3c597","453":"098be962","455":"13db7c52"}[chunkId] + ".chunk.js";
};